module.exports = __webpack_public_path__ + "static/img/icon16.d9afc86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon16.png
// module id = O3eg
// module chunks = 0